import logoutIcon from "../assets/svg/logout-icon.svg";
import { useNavigate } from "react-router-dom";

const LogoutButton = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("authToken"); // Clear the auth token from localStorage
    localStorage.removeItem("refreshToken");
    navigate("/"); // Redirect to the home page or login page
  };

  return (
    <button
      onClick={handleLogout}
      className="absolute right-4 top-4 z-[999] text-[#ED2C08] transition hover:text-red-700"
      aria-label="Log out"
    >
      <img src={logoutIcon} alt="Log out" className="h-8 w-8" />
    </button>
  );
};

export default LogoutButton;
